import fetch from "./fetch-leads-api";
import { getPCUID, getPCSID } from "../utils/pcuid-cookie";

function createExtensionCategory(category, extensions) {
  return extensions.reduce((extensions, extension) => {
    extensions[`${category}_${extension.name}`] = { ...extension, category };
    return extensions;
  }, {});
}

function offerExtension(vehicle) {
  return createExtensionCategory(
    "Trade-In Offer Values",
    ["Rough", "Average", "Excellent"].map((name, idx) => ({
      name,
      value:
        vehicle && vehicle.tradeInRanges
          ? vehicle.tradeInRanges[idx]
          : "See Dealer",
      isPublic: true,
    }))
  );
}

function vehicleExtensionFactory(category) {
  return function vehicleExtension(vehicle) {
    return createExtensionCategory(
      category,
      [
        { name: "Year", value: vehicle.year },
        { name: "Make", value: vehicle.make },
        { name: "Model", value: vehicle.model },
        { name: "Trim", value: vehicle.trim },
        { name: "Interest", value: vehicle.interest },
        { name: "Condition", value: vehicle.condition },
        { name: "IsOneOwner", value: vehicle.singleOwner },
        {
          name: "Accessories",
          value:
            vehicle.accessories && vehicle.accessories.length > 0
              ? vehicle.accessories
                  .map(({ description }) => description)
                  .join(", ")
              : undefined,
        },
        { name: "Odometer", value: vehicle.miles },
        { name: "Vin", value: vehicle.vin },
      ]
        .map(({ name, value }) => ({ name, value, isPublic: true }))
        .filter(({ value }) => typeof value !== "undefined")
    );
  };
}

function tradeVehicleExtension(vehicle) {
  return vehicleExtensionFactory("Trade-In Vehicle")({
    ...vehicle,
    interest: "trade-in",
    condition: "used",
  });
}

function interestedVehicleExtension(vehicle) {
  if (!vehicle) {
    return {};
  }
  return vehicleExtensionFactory("Trade-In Interested Vehicle")({
    ...vehicle,
    interest: "buy",
  });
}

async function submitLead({
  leadId,
  contact,
  tradeVehicle,
  interestedVehicle,
  account,
  // Lead info
  actionName,
  leadUrl,
}) {
  const campaignName = `PureCars Trade Report v3.0.0`;
  console.log("CONTACT");
  console.log(JSON.stringify(contact));
  const { message = "" } = contact;

  contact.message = `${
    account.name
  }: This customer came from PureCars trade in report.\n
    Which can be viewed here: ${leadUrl}.\n
    Zip Code: ${contact.postalCode}\n
    Accepted Disclaimer: ${contact.acceptedDisclaimer ? "yes" : "no"}
    ${message ? `\nCustomer Message:${message}` : ""}
    `.trim();

  const provider = {
    name: "PureCars",
    service: `Trade In Report v3.0.0`,
    url: "https://www.purecars.com",
    email: "support@purecars.com",
  };

  const vendor = {
    accountName: account.name,
  };

  const context = {
    sourceName: campaignName,
    accountId: account.id,
    pcuid: getPCUID(),
    sourceId: getPCSID(),
    vin: interestedVehicle && interestedVehicle.vin,
    actionName,
    leadUrl,
  };

  const campaignDetails = createExtensionCategory("Campaign Details", [
    { name: "campaign name", value: campaignName },
    { name: "accepted disclaimer", value: contact.acceptedDisclaimer },
  ]);

  const contactCategory = {};
  if (contact.acceptedDisclaimer !== undefined) {
    contactCategory["Contact Information 0"] = {
      category: "Contact Information",
      name: "Accepted Disclaimer",
      value: contact.acceptedDisclaimer,
      isPublic: true,
    };
  }

  if (contact.preferredMethodOfContact) {
    contactCategory["Contact Information 1"] = {
      category: "Contact Information",
      name: "Preferred Method of Contact",
      value: contact.preferredMethodOfContact,
      isPublic: true,
    };
  }

  const extension = {
    SourceUrl: {
      category: "Lead Details",
      name: "Lead URL",
      value: leadUrl,
      isPublic: true,
    },
    ...contactCategory,
    ...campaignDetails,
    ...offerExtension(tradeVehicle),
    ...tradeVehicleExtension(tradeVehicle),
    ...interestedVehicleExtension(interestedVehicle),
  };

  const info = { leadId, provider, vendor, contact, context, extension };

  const resp = await fetch(`/v2/submit`, {
    method: "POST",
    body: JSON.stringify(info),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (resp.status === 400) {
    const errors = await resp.json();
    throw errors.map((err) => {
      return {
        fieldName: err.fieldName,
        message: err.message,
      };
    });
  }

  return resp.json();
}

export default submitLead;
